import { extractSectionOps } from "./index.js";
import { collectWindowOps, groupActivity, distinctKey } from "../../src/build/index.js";

export const extract = extractSectionOps;
export const informedness = (op) => op.answered * 100 + (op.asked - op.lost);
export const collect = (prompts) => collectWindowOps(prompts, { informedness });

// The PROGRAM being scripted. Two calls driving the same tool through different
// question sets are the same kind of act; the questions themselves are the content,
// not the identity.
export const groupBy = (op) => op.program || distinctKey("unnamed program", op);

export const build = (flat) => groupActivity(flat, {
  key: groupBy,
  label: (op) => {
    const extra = (op.programs || []).length - 1;
    return `scripted ${op.program}${extra > 0 ? ` +${extra} more` : ""}`;
  },
  seed: () => ({ kinds: {}, outcomes: {}, labels: [], deepest: 0, lost: 0, empty: 0 }),
  fold: (g, op) => {
    g.kinds[`${op.answered} questions`] = (g.kinds[`${op.answered} questions`] || 0) + 1;
    g.outcomes[op.lost ? "some never reached" : "all reached"] = (g.outcomes[op.lost ? "some never reached" : "all reached"] || 0) + 1;
    if (op.answered > g.deepest) g.deepest = op.answered;
    g.lost += op.lost;
    g.empty += op.emptySections;
  },
  finish: (g) => {
    g.labels = [
      `up to ${g.deepest} questions in one call`,
      g.lost ? `${g.lost} never reached` : null,
      g.empty ? `${g.empty} answered empty` : null,
    ].filter(Boolean);
  },
});

export const anchor = () => "echo";
export const ignore = ["output", "steps", "checks", "sections"];
